import { notifyError } from '@v4/utils/bugsnag'
import { parseValidationError } from './index'
import { getXsrfToken, storeSASIDtoUrl } from './cookie'

const storeSasid = ({ sasid }, store) => {
	if (!sasid) {
		return
	}

	_.set(window.initialData, 'tokens.sasid', sasid)

	if (store) {
		store.getActions().updateTokens({ sasid })
	}

	storeSASIDtoUrl(sasid)
}

const getSasid = store => {
	const sasid = store ? store.getState().tokens.sasid : _.get(window.initialData, 'tokens.sasid')
	if (sasid) return sasid

	const urlParams = new URLSearchParams(window.location.search)
	return urlParams.get('SASID')
}

const addInterceptor = axiosInstance => {
	axiosInstance.interceptors.response.use(
		response => {
			storeSasid(response.headers, axiosInstance.store)

			return response
		},
		error => {
			if (error?.response instanceof Object) {
				const { status, data, headers } = error.response

				if (status === 429) {
					window.location.reload()
				}

				storeSasid(headers, axiosInstance.store)

				if (status === 419) {
					const metadata = {
						settings: {
							cookieEnabled: navigator.cookieEnabled,
						},
					}
					if (error.config) {
						metadata.headers = error.config.headers
						metadata.payload = error.config.data
					}

					notifyError(error, {
						metaData: metadata,
						message: '419 Error',
					})
				}

				if (status === 422) {
					return Promise.reject(data.errors ? parseValidationError(data.errors) : data.error)
				}
			}
			return Promise.reject(error)
		},
	)

	axiosInstance.interceptors.request.use(config => {
		const xsrfToken = getXsrfToken()

		if (xsrfToken) {
			// eslint-disable-next-line no-param-reassign
			config.headers['X-XSRF-TOKEN'] = decodeURIComponent(xsrfToken)
		} else {
			// eslint-disable-next-line no-param-reassign
			config.headers['X-CSRF-TOKEN'] =
				window.initialData.tokens?.csrf ||
				document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
		}

		try {
			if (window.parent.location.host !== window.location.host) {
				throw new Error()
			}
		} catch (e) {
			// eslint-disable-next-line no-param-reassign
			config.headers.sasid = getSasid(axiosInstance.store)
		}

		return config
	})
}

// eslint-disable-next-line import/prefer-default-export
export { addInterceptor }
